import { EntityRepository, Repository } from "typeorm";
import { Recruitment } from "./recruitment.entity";



@EntityRepository(Recruitment)
export class RecruitmentRepository extends Repository<Recruitment>{

}
